module.exports = __webpack_public_path__ + "assets/32c8c6808de0fecfe74b6fa156be80bf.jpg";